var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0006 5C18.4326 5 5.00024 18.4315 5.00024 35.0003C5.00024 51.5688 18.4326 65 35.0006 65C51.5696 65 65.0009 51.5688 65.0009 35.0003C65.0009 18.4315 51.5696 5 35.0006 5ZM45.4856 41.0022L33.7025 41.0027C33.6304 41.0133 33.5575 41.0186 33.4845 41.0187C32.6555 41.0187 31.9845 40.3467 31.9845 39.5189L31.9839 17.0208C31.9839 16.1923 32.6638 15.5205 33.4922 15.5205C34.321 15.5205 35.0006 16.1915 35.0006 17.0208V38.0171H45.4862C46.3138 38.0171 46.9856 38.6818 46.9856 39.5093C46.9856 40.3378 46.3138 41.0022 45.4856 41.0022Z",
    fill: "#5065E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPlace);
export default __webpack_public_path__ + "static/media/order-place.bc7ab854.svg";
export { ForwardRef as ReactComponent };